import React from 'react';
import { m } from 'framer-motion';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { trustStats, trustBadges } from '../../data/trustStats';
export function TrustStats() {
  return <section className="border-y border-gris-claro bg-bg-secondary py-8 sm:py-10" data-id="element-255" data-mp="37qiugn60s8wn">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-256" data-mp="32sh9fwp19zij">
        <ScrollHintTable minWidth="640px" data-id="element-257" data-mp="32rz6yibs2p26">
          <div className="grid grid-cols-4 divide-x divide-gris-claro bg-white" data-id="element-258" data-mp="2yqdp0ikdzkl4">
            {trustStats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-259" data-mp="2tyvuodcvci94" data-mpi={i}>
                <stat.icon size={22} className="text-azul" data-id="element-260" data-mp="2b11d3axocyf4" />
                <span className="font-heading text-xl font-bold text-naranja sm:text-2xl" data-id="element-261" data-mp="2b1kvesr8loto">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-262" data-mp="191yltroxcgi1">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-semibold uppercase tracking-wider text-azul" data-id="element-263" data-mp="z5vf08j4ntor">
          ✓ El Estándar Profesional en la Pista
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-264" data-mp="1ru0x0nisr4kw">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-gris-claro bg-white p-5 shadow-card" data-id="element-265" data-mp="1wslxmo1ynq9v" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-azul-light" data-id="element-266" data-mp="7gaehw4kw547">
                <badge.icon size={20} className="text-azul" data-id="element-267" data-mp="2e26mn13ijmln" />
              </div>
              <div data-id="element-268" data-mp="2e49frtzypvul">
                <p className="font-heading text-sm font-semibold text-azul-dark" data-id="element-269" data-mp="293d9xaw1vzmj">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-270" data-mp="24cda9xvjr3gc">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}